<script setup>
    /**
     * Vue Scripts
     */
    import {onMounted} from "vue";
    import {trialStore} from "@pinia/trial-store";
    import {locationsAndMarkers} from "@util/map";

    /**
     * Vue Components
     */
    import Locations from "@pages/Trial/TrialMap/Listing/Locations/Locations.vue"
    import SearchBar from "@pages/Trial/TrialMap/Listing/SearchBar/SearchBar.vue"

    const store = trialStore();

    onMounted(() => {
        const {apiUrl, language, postId} = TRIAL;
        const {defaultCoords} = LOC?.mapSettings || {};
        const lat = parseFloat(defaultCoords?.latitude)
        const lng = parseFloat(defaultCoords?.longitude)

        store.$patch({
            loading: true,
            query: {
                language,
                lat,
                lng,
                newLocation: false,
                postId,
                ppp: 5,
            },
        })

        locationsAndMarkers(apiUrl, store.query)
            .then(({locations, markers}) => (locations && markers) && store.$patch({locations, markers}))
            .finally(() => store.$patch({loading: false}))
    })
</script>

<template>
    <aside>
        <SearchBar />
        <Locations />
    </aside>
</template>

<script>
    export default {
        name: "Listing"
    }
</script>

<style scoped lang="scss">

</style>
